import { useEffect, useRef, useState } from "react";

export function Reveal({ children, delay = 0, as: Tag = "div" }) {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const node = ref.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTimeout(() => setIsVisible(true), delay);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.1 }
    );

    if (node) {
      observer.observe(node);
    }

    return () => {
      if (node) {
        observer.unobserve(node);
      }
    };
  }, [delay]);

  return (
    <Tag ref={ref} className={`reveal ${isVisible ? "in" : ""}`}>
      {children}
    </Tag>
  );
}
